import ERPExchangeAccessModal from './ERP_exchange_access-modal.vue'
export default ERPExchangeAccessModal
